<div class="admin-modal" role="dialog" aria-labelledby="modal-title" aria-modal="true">
  <div class="admin-modal__title">
    <div class="title-container">
      <mat-icon class="icon-xl" svgIcon="need_capture" aria-hidden="true"></mat-icon>
      <h1 id="modal-title" class="heading-s">
        Search product
      </h1>
    </div>
    <mat-icon
      class="icon-m"
      (click)="closeModal()"
      aria-label="Close modal"
      tabindex="0"
      role="button">
      close
    </mat-icon>
  </div>
  <div class="admin-modal__content">
    <div class="search-container">
      <mat-form-field appearance="fill">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput placeholder="Search" [formControl]="searchControl" />
      </mat-form-field>
    </div>

    @if(productList.length > 0 && !adminService.isLoadingProducts()) {
      <span class="body-m">{{ productList.length }} results</span>
      <div class="products-list">
        @for (product of productList; track product) {
          <div class="product-item">
            <div class="product-image">
              <img [src]="product.imageUrl" alt="fragrance" height="88" width="88" loading="lazy"/>
            </div>
            <div class="product-content">
              <section>
                <span class="body-l-bold">{{ product.name }}</span>
                <div class="product-sku-price">
                  <div class="product-label-container">
                    <span class="product-label body-m">SKU:</span>
                    <span class="body-m">{{ product.sku }}</span>
                  </div>
                  <span>-</span>
                  <div class="product-label-container">
                    <span class="product-label body-m">Unit price:</span>
                    <span class="body-m">{{ product.price.value | defaultCurrency: product.price.currencyCode }}</span>
                  </div>
                </div>
              </section>
              <span class="body-m product-description" [innerHTML]="product.description"></span>
            </div>
            <div class="product-checkbox">
              <mat-checkbox [checked]="isSelected(product) || isSelectedProduct(product)" [disabled]="isSelectedProduct(product) || (!isSelected(product) && isMaxProductsSelected())" (change)="toggleProductSelection(product)" class="bany-checkbox"></mat-checkbox>
            </div>
          </div>
        }
      </div>
    }
    @if(adminService.isLoadingProducts()) {
      <div class="products-empty-container">
        <mat-spinner></mat-spinner>
      </div>
    }
    <div class="products-empty-container" *ngIf="productList.length === 0 && !adminService.isLoadingProducts()">
      <mat-icon svgIcon="bottles_dark" class="products-icon"></mat-icon>
      <span class="body-m">No products found. Try another search.</span>
    </div>
  </div>

  <div class="admin-modal__footer">
    <app-button
      type="primary"
      size="large"
      [disabled]=" selectedProducts.length === 0"
      [text]="'Add to proposals (' + selectedProducts.length + ')'"
      iconPosition="right"
      icon="arrow_forward"
      (click)="addProducts()">
    </app-button>
  </div>
</div>
